import { createContext, useReducer, useContext, useEffect } from "react";
import { socket } from "../hooks/useFilteredProducts";

const initialState = {
  carrito: JSON.parse(localStorage.getItem("carrito")) || [], // Cargar carrito del localStorage
};

// Reducer para manejar acciones del carrito
const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_CART":
      const productInCart = state.carrito.find(
        (item) => item.id === action.payload.id
      );

      if (productInCart) {
        return {
          ...state,
          carrito: state.carrito.map((item) =>
            item.id === action.payload.id
              ? { ...item, quantity: item.quantity + 1 }
              : item
          ),
        };
      } else {
        return {
          ...state,
          carrito: [...state.carrito, { ...action.payload, quantity: 1 }],
        };
      }
    case "SUBTRACT_TO_CART":
      const product = state.carrito.find(
        (item) => item.id === action.payload.id
      );
      if (product) {
        if (product.quantity > 1) {
          // Si la cantidad es mayor que 1, simplemente restamos 1
          return {
            ...state,
            carrito: state.carrito.map((item) =>
              item.id === action.payload.id
                ? { ...item, quantity: item.quantity - 1 }
                : item
            ),
          };
        } else {
          // Si la cantidad es 1, eliminamos el producto del carrito

          return {
            ...state,
            carrito: state.carrito.filter(
              (item) => item.id !== action.payload.id
            ),
          };
        }
      }
      // Si el producto no existe en el carrito, retornamos el estado sin cambios
      return state;
    case "REMOVE_FROM_CART":
      return {
        ...state,
        carrito: state.carrito.filter((item) => item.id !== action.payload.id),
      };
    case "REMOVE_CART":
      return {
        ...state,
        carrito: action.payload,
      };
    case "UPDATE_CART_PRODUCT":
      return {
        ...state,
        carrito: state.carrito.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        ),
      };

    case "SYNC_CART":
      return {
        ...state,
        carrito: action.payload, // Actualizar el carrito globalmente
      };

    default:
      return state;
  }
};

// Crear contexto
const CartContext = createContext();

// Proveedor del carrito para englobar toda la app
export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);
  //const carritoLocal = JSON.parse(localStorage.getItem('carrito'))
  // Guardar carrito en localStorage cada vez que se actualiza
  useEffect(() => {
    localStorage.setItem("carrito", JSON.stringify(state.carrito));
  }, [state.carrito]);

  // Escuchar actualizaciones en tiempo real con WebSocket
  useEffect(() => {
    socket.on("productoActualizado", (updatedProduct) => {
      if (!updatedProduct.disponible) {
        dispatch({ type: "REMOVE_FROM_CART", payload: updatedProduct });
      } else {
        dispatch({ type: "UPDATE_CART_PRODUCT", payload: updatedProduct });
      }
    });

    return () => {
      socket.off("productoActualizado");
    };
  }, []);

  // Sincronizar carrito con productos disponibles al cargar la aplicación
  const syncCart = async () => {
    const carritoLocal = JSON.parse(localStorage.getItem("carrito")) || [];
    if (carritoLocal.length > 0) {
      try {
        const response = await fetch(
          `https://backend-verduleria-production.up.railway.app/api/products`
        );

        const allProducts = await response.json();

        const syncedCart = carritoLocal
          .filter((item) => {
            const product = allProducts.find((p) => p.id === item.id);
            return product && product.disponible;
          })
          .map((item) => {
            const product = allProducts.find((p) => p.id === item.id);
            return { ...item, ...product };
          });

        dispatch({ type: "SYNC_CART", payload: syncedCart });
      } catch (error) {
        console.error("Error al sincronizar el carrito:", error);
      }
    }
  };

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};

// Hook para acceder al carrito
export const useCart = () => useContext(CartContext);
